import { type JSX, type ComponentChildren } from 'preact';

interface CardProps {
  children: ComponentChildren;
  className?: string;
}

export function Card({ children, className = '' }: CardProps): JSX.Element {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-md dark:shadow-gray-900/50 p-6 transition-colors duration-200 ${className}`}>{children}</div>
  );
}

interface CardHeaderProps {
  children: ComponentChildren;
  className?: string;
}

export function CardHeader({ children, className = '' }: CardHeaderProps): JSX.Element {
  return <div className={`mb-4 ${className}`}>{children}</div>;
}

interface CardTitleProps {
  children: ComponentChildren;
  className?: string;
}

export function CardTitle({ children, className = '' }: CardTitleProps): JSX.Element {
  return <h2 className={`text-2xl font-bold text-gray-900 dark:text-gray-100 transition-colors duration-200 ${className}`}>{children}</h2>;
}

interface CardDescriptionProps {
  children: ComponentChildren;
  className?: string;
}

export function CardDescription({
  children,
  className = '',
}: CardDescriptionProps): JSX.Element {
  return <p className={`text-gray-600 dark:text-gray-400 text-sm transition-colors duration-200 ${className}`}>{children}</p>;
}

interface CardContentProps {
  children: ComponentChildren;
  className?: string;
}

export function CardContent({ children, className = '' }: CardContentProps): JSX.Element {
  return <div className={`space-y-4 ${className}`}>{children}</div>;
}

interface CardFooterProps {
  children: ComponentChildren;
  className?: string;
}

export function CardFooter({ children, className = '' }: CardFooterProps): JSX.Element {
  return <div className={`mt-6 flex gap-2 justify-end ${className}`}>{children}</div>;
}
